export default class ToggleSwitchColors {
  static red = 'red';
  static blue = 'blue';
}
